/**
 * What this build says it is: package.json's version and the commit it was
 * built from, "0.5.3 (2e735c6)" (scripts/app-version.mjs). The hotkey guide
 * shows it, and an update names the one it brought.
 */
export const APP_VERSION: string = __BOZZETTO_VERSION__;
